/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/information_medium'
export default icon
